<script lang="ts">
    import TreeBackground from "./TreeBackground.svelte";
</script>

<!-- <img src="/static/front_images/fast2.jpg" /> -->
<main>
    <TreeBackground />
    <h1>404</h1>
    Vi kunde tyvärr inte hitta sidan du letade efter
</main>

<svelte:head>
    <title>404 - Not found</title>
</svelte:head>

<style>
    main {
        display: flex;
        align-items: center;
        width: 100%;
        flex-direction: column;
    }

    h1 {
        font-size: 200px;
    }
</style>
